/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "vtpmiwgvvnfqjxtgotda"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ0cG1pd2d2dm5mcWp4dGdvdGRhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE5MTI1NzcsImV4cCI6MjA3NzQ4ODU3N30.q0PxtPGv_u7MQyfDe3cNWHsaBlQ3nTaJWUFNBK2VcxU"